/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import { ProfileLayout } from 'v4/snippets/profile/layout';
import { MyProfile } from 'v4/snippets/profile/private';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';

const Profile = () => {
  return (
    <AuthenticatedProviders>
      <ProfileLayout active={0}>
        <MyProfile /> 
      </ProfileLayout>
    </AuthenticatedProviders>
  );
};

export default Profile;
